import checklistTemplatesListHtml from "./states/list/list.html";
import checklistTemplatesEditorHtml from "./states/editor/editor.html";
import qaListHtml from "./states/qaList/qa_list.html";
import qaEditorHtml from "./states/qaEditor/qa_editor.html";

export default function ($stateProvider, SABLONO_STATES) {
    "ngInject";

    $stateProvider.state(SABLONO_STATES.checklistTemplatesList, {
        url: "/list",
        templateUrl: checklistTemplatesListHtml,
        controller: "ChecklistTemplatesListCtrl",
        controllerAs: "list",
        gaPageTrack: "/checklistTemplates/list",
        resolve: {
            access: checklistTemplateMigrationAccess(
                false,
                SABLONO_STATES.qaList
            ),
        },
        data: {
            category: "PLAN", // REVIEW or WORK
            title: "CHECKLIST_TEMPLATE_PAGE_NAME",
        },
    });

    $stateProvider.state(SABLONO_STATES.checklistTemplatesEditor, {
        url: "/editor/:checklistTemplateId",
        templateUrl: checklistTemplatesEditorHtml,
        controller: "ChecklistTemplatesEditorCtrl",
        controllerAs: "editor",
        gaPageTrack: "/checklistTemplates/editor",
        resolve: {
            access: checklistTemplateMigrationAccess(
                false,
                SABLONO_STATES.qaEditor
            ),
        },
        data: {
            category: "PLAN", // REVIEW or WORK
            title: "CREATE_CHECKLIST_EDITOR_TITLE",
            hasBackButton: true,
            backButtonTarget: SABLONO_STATES.checklistTemplatesList,
        },
    });

    $stateProvider.state(SABLONO_STATES.qaList, {
        url: "/checklist-templates",
        templateUrl: qaListHtml,
        gaPageTrack: "/qa-list",
        resolve: {
            access: checklistTemplateMigrationAccess(
                true,
                SABLONO_STATES.checklistTemplatesList
            ),
        },
        data: {
            category: "PLAN",
            title: "ACTION_NAV_TO_TEMPLATE_CHECKLIST_V2",
        },
    });

    $stateProvider.state(SABLONO_STATES.qaEditor, {
        url: "/checklist-template-editor/:checklistTemplateId",
        templateUrl: qaEditorHtml,
        gaPageTrack: "/qa-editor",
        resolve: {
            access: checklistTemplateMigrationAccess(
                true,
                SABLONO_STATES.checklistTemplatesEditor
            ),
        },
        data: {
            category: "PLAN",
            title: "ACTION_NAV_TO_TEMPLATE_CHECKLIST_V2",
        },
    });
}

/**
 * Guards entry to a v1/v2 checklist templates page, redirecting to its counterpart when the migration
 * criteria disagree with where the user landed. Whether the request-access page should be shown at all
 * is decided by the page access guard, not here.
 *
 * @param {boolean} isNewPage - true if the page being guarded is the new v2 page, false if it is the old v1 page
 * @param {string} redirectTarget - the state to redirect to if the user is not eligible for the page being guarded
 * @returns
 */
function checklistTemplateMigrationAccess(isNewPage, redirectTarget) {
    return function (
        project, // required to force waiting until the parent state's project resolve is loaded
        $stateParams,
        $state,
        $log,
        $sbChecklistTemplateMigration
    ) {
        "ngInject";

        return $sbChecklistTemplateMigration
            .shouldUseNewChecklistTemplatesPage()
            .catch(function (error) {
                $log.warn(
                    "Unable to evaluate checklist templates migration eligibility, staying on current page",
                    error
                );
                return false;
            })
            .then(function (shouldUseNewPage) {
                if (shouldUseNewPage === isNewPage) {
                    return;
                }

                $log.debug(
                    "[ChecklistTemplateMigration] redirecting to",
                    redirectTarget
                );

                // Returning the transition supersedes the current one instead of letting it continue.
                // $stateParams already carries projectId (and checklistTemplateId for the editor) from the current transition.
                //
                return $state.go(redirectTarget, $stateParams, {
                    location: "replace",
                });
            });
    };
}
